import React from "react";
import { Routes, Route } from "react-router";
import XSifterLogin from "../XSifterLogin";
import XSifterExternalHeader from "./XSifterExternalHeader";
import "./XSifterExternalPage.css"
import Container from "@mui/material/Container";
import DiscoverTextOAuthLogin from "./DiscoverTextOAuthLogin";
import XSifterNotApproved from "../XSifterNotApproved";

class XSifterExternalPage extends React.Component {
    render() {
        return (
            <>
            <XSifterExternalHeader />
            <Container className={"xxsifterpagecontent"}>
            <Routes>
                <Route path="/oauth/login" element={<DiscoverTextOAuthLogin />} />
                <Route path="/needs-approval" element={<XSifterNotApproved />} />
                <Route path="*" element={<XSifterLogin />} />
            </Routes>
            </Container>
            </>
        );
    }
}

export default XSifterExternalPage;
